export default function identity(positionalA /*, positionalB, named*/) {
  return positionalA;
}
